'use strict';

var define = require('define-properties');

var getPolyfill = require('./polyfill');

module.exports = function shimArrayPrototypeIncludes() {
  var polyfill = getPolyfill();
  define(Array.prototype, {
    includes: polyfill
  }, {
    includes: function includes() {
      return Array.prototype.includes !== polyfill;
    }
  });
  return polyfill;
};